import { BettyHistoryModuleType } from "UidispatcherApiModule";
const { BettyHistoryModule }: { BettyHistoryModule: BettyHistoryModuleType } =
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");

export default BettyHistoryModule;
